import { StateCode } from './state-code.model';

export enum Shape {
  circle = 'circle',
}

export type Boundary = {
  shape: Shape; // Shape of the location boundary
  radius: number; // Radius of a perfect circle around the location center that counts as part of the location, up to 610 meters
};

export type NamedLocation = {
  addressLine1?: string; // Street number, name, and possible unit number
  addressLine2?: string; // Second line of street address - not usually used
  city?: string; // City municipality name
  stateCode?: StateCode; // USPS standard two-letter code for a state
  county?: string; // County municipality name
  zipCode?: string; // USPS ZIP code
  latitude: number; // GPS latitude
  longitude: number; // GPS longitude
  placeID?: string; // Google Map unique ID for this address
  timeZone?: string; // Timezone of the address as an IANA identifier
  name: string; // Name of the business or facility at this location
  reason: string; // Simple explanation as to why this location is included in this database
  boundary: Boundary;
  namedLocationUUID: string; // Unique primary key of this Location
  geoHash: string; // Hash code describing this grid position on the globe this named location sits within
  modifiedByUserID: string; // ID of the last user to modify this entity; or SYSTEM
  modifiedDateTimeUTC: string; // The last time this entity was modified
  correlationUUID: string; // Application-wide unique ID for this entity instance
};

export type CreatableNamedLocation = {
  addressLine1?: string; // Street number, name, and possible unit number
  addressLine2?: string; // Second line of street address - not usually used
  city?: string; // City municipality name
  stateCode?: string; // USPS standard two-letter code for a state
  county?: string; // County municipality name
  zipCode?: string; // USPS ZIP code
  latitude: number; // GPS latitude
  longitude: number; // GPS longitude
  placeID?: string; // Google Map unique ID for this address
  timeZone?: string; // Timezone of the address as an IANA identifier
  name: string; // Name of the business or facility at this location
  reason: string; // Simple explanation as to why this location is included in this database
  boundary: Boundary; // Placeholder for boundary type, replace `any` with the actual type
};

export type EditableNamedLocation = CreatableNamedLocation & {
  namedLocationUUID: string;
};

export type DeleteNamedLocationRequest = {
  namedLocationUUID: string;
};
